// extracted by mini-css-extract-plugin
export var hideEditor = "_il-2";
export var infoIcon = "_il-3";
export var label = "_il-1";
export var labelContainer = "_il-0";
export var readonlyText = "_il-4";